import styled from 'styled-components'

export const PermitDetailContainer = styled.div`
  padding: 0;
`

export const PermitBackBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #00ade6;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  margin-bottom: 24px;
  transition: all 0.2s;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    gap: 8px;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`

export const PermitDetailCard = styled.div`
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
`

export const CardHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #e5e5e5;
  background: #fafafa;
`

export const CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const CardTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
`

export const PermitBadge = styled.span<{ variant: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  text-transform: capitalize;

  ${({ variant }) => {
    switch (variant) {
      case 'development':
        return `
          background: rgba(0, 173, 230, 0.1);
          color: #0099cc;
        `
      case 'renovation':
        return `
          background: rgba(255, 149, 0, 0.1);
          color: #ff8800;
        `
      case 'transformation':
        return `
          background: rgba(128, 90, 213, 0.1);
          color: #7b61ff;
        `
      case 'elevation':
        return `
          background: rgba(0, 179, 65, 0.1);
          color: #00b341;
        `
      case 'regularisation':
        return `
          background: rgba(255, 59, 48, 0.1);
          color: #ff3333;
        `
      default:
        return `
          background: rgba(107, 107, 107, 0.1);
          color: #6b6b6b;
        `
    }
  }}
`

export const CardBody = styled.div`
  padding: 24px;
`

export const LocationSection = styled.div`
  margin-bottom: 24px;
`

export const PermitDetailLocation = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #6b6b6b;
  margin-bottom: 4px;

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`

export const PermitDetailDate = styled.div`
  font-size: 13px;
  color: #999999;
`

export const DataGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`

export const DataGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const DataSectionTitle = styled.h3`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #999999;
  margin: 0 0 8px 0;
`

export const DataRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
`

export const DataLabel = styled.span`
  font-size: 13px;
  color: #6b6b6b;
`

export const DataValue = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
  text-align: right;
`

export const PermitStatusBadge = styled.span<{ variant: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  ${({ variant }) => {
    switch (variant) {
      case 'instruction':
        return `
          background: rgba(0, 173, 230, 0.1);
          color: #00ade6;
        `
      case 'enregistrement':
      case 'approved':
        return `
          background: rgba(0, 179, 65, 0.1);
          color: #00b341;
        `
      case 'pending':
        return `
          background: rgba(255, 149, 0, 0.1);
          color: #ff9500;
        `
      case 'rejected':
        return `
          background: rgba(255, 59, 48, 0.1);
          color: #ff3b30;
        `
      case 'completed':
        return `
          background: rgba(107, 107, 107, 0.1);
          color: #6b6b6b;
        `
      default:
        return `
          background: rgba(107, 107, 107, 0.1);
          color: #6b6b6b;
        `
    }
  }}
`

export const ProjectDescriptionSection = styled.div`
  margin-top: 32px;
`

export const ProjectDescription = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #1a1a1a;
  background: #f8f8f8;
  padding: 16px;
  border-radius: 6px;
  margin: 0;
`

export const ProjectParticipantsSection = styled.div`
  margin-top: 32px;
`

export const ActionSection = styled.div`
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e5e5e5;
`

export const PublicInquiryBtn = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #00ade6;
  text-decoration: none;
  transition: all 0.2s;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    background: rgba(0, 173, 230, 0.05);
    border-color: #00ade6;
  }
`
